module.exports = __webpack_public_path__ + "img/arrow-prev.15646e49.svg";